import React from "react";
import { Outlet } from "react-router-dom";

const Web3Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Web3Layout;
